import React from 'react'
import InputLabel from '@mui/material/InputLabel'
import NotchedOutline from '@mui/material/OutlinedInput/NotchedOutline'
import { useRef } from 'react'
import { useState } from 'react'
import { useEffect } from 'react'

import * as classStyles from './LabelledOutline.module.scss'

const styles = {
  root: {
    position: 'relative',
    height: 'fit-content',
  },
  contentWrapper: {
    position: 'relative',
  },
  content: {
    padding: '18.5px 14px',
  },
  inputLabel: {
    position: 'absolute',
    left: 0,
    top: 0,
    // slight alteration to spec spacing to match visual spec result
    transform: 'translate(0, 24px) scale(1)',
  },
  notchedOutline: {
    borderRadius: '8px',
    border: '2px solid red',
  },
}

export const LabelledOutline = ({
  customStyle = {},
  id,
  label,
  children,
  className,
  centerLabel = false,
  noWrap = true,
}) => {
  const [labelWidth, setLabelWidth] = useState(0)
  const labelRef = useRef(null)
  useEffect(() => {
    const labelNode = labelRef.current
    setLabelWidth(labelNode != null ? labelNode.offsetWidth : 0)
  }, [label])

  const mergedStyles = {
    ...styles,
    ...customStyle,
  }

  return (
    <div
      style={{
        ...mergedStyles.root,
        ...className,
      }}
    >
      <InputLabel
        sx={{
          top: 0,
          transform: centerLabel
            ? 'translate(14px, 50%) scale(0.72)'
            : 'translate(14px, 14px) scale(0.72)',
          whiteSpace: noWrap ? 'nowrap' : 'normal',
          width: centerLabel ? 'max-content' : null,
        }}
        ref={labelRef}
        htmlFor={id}
        variant="outlined"
        shrink
      >
        {label}
      </InputLabel>
      <div
        style={{
          ...mergedStyles.contentWrapper,
        }}
      >
        <div
          id={id}
          className={classStyles.labelledNotchedOutlined}
          style={{
            ...mergedStyles.content,
          }}
        >
          {children}
          <NotchedOutline label={label} notched labelwidth={labelWidth} />
        </div>
      </div>
    </div>
  )
}
